// Shared by insertRole.js (Create Role) and ListRole.js (Edit Role) so a
// role's permissions can't accidentally list the same Page twice. Each
// row's Page dropdown excludes pages already chosen by any *other* row in
// the same permissions array, while still showing this row's own current
// selection (so picking a page doesn't make it vanish from its own row).
export function getAvailablePages(pageOptions, permissions, currentIndex) {
  const selectedElsewhere = new Set(
    permissions
      .filter((_, i) => i !== currentIndex)
      .map((p) => p.pageId)
      .filter(Boolean)
      .map(String)
  );
  return pageOptions.filter((page) => !selectedElsewhere.has(String(page.id)));
}

// Disables "Add Permission" once every available page already has a row —
// there'd be nothing left for a new row's dropdown to offer.
export function allPagesAssigned(pageOptions, permissions) {
  if (pageOptions.length === 0) return false;
  const assigned = new Set(permissions.map((p) => p.pageId).filter(Boolean).map(String));
  return assigned.size >= pageOptions.length;
}
